export const ACCOUNT_TYPES = [
	{ value: "asset", label: "Asset" },
	{ value: "liability", label: "Liability" },
	{ value: "equity", label: "Equity" },
	{ value: "income", label: "Income" },
	{ value: "expense", label: "Expense" },
];

export const AMOUNT_KEYS = [
	{ value: "amount", label: "amount — principal (rent / payout / expense)" },
	{ value: "fee_paid", label: "fee_paid — fee / charge component" },
	{ value: "gross", label: "gross — amount + fee_paid" },
];

export const LINE_SIDES = [
	{ value: "debit", label: "Debit" },
	{ value: "credit", label: "Credit" },
];

export const STARTER_ACCOUNTS = [
	{ code: "1000", name: "Cash on hand", account_type: "asset" },
	{ code: "1010", name: "MTN MoMo wallet", account_type: "asset" },
	{ code: "1020", name: "Airtel Money wallet", account_type: "asset" },
	{ code: "1030", name: "Bank clearing", account_type: "asset" },
	{ code: "1040", name: "Airtel Merchant clearing", account_type: "asset" },
	{ code: "2000", name: "Landlord payable", account_type: "liability" },
	{ code: "4000", name: "Rent income", account_type: "income" },
	{ code: "4100", name: "Service fee income", account_type: "income" },
	{ code: "5000", name: "Property expenses", account_type: "expense" },
];

export const PAYMENT_METHOD_EXAMPLES = [
	{ method: "Cash", account: "1000 Cash on hand" },
	{ method: "MTN", account: "1010 MTN MoMo wallet" },
	{ method: "Airtel", account: "1020 Airtel Money wallet" },
	{ method: "Bank", account: "1030 Bank clearing" },
	{ method: "Airtel Merchant", account: "1040 Airtel Merchant clearing" },
];

export const TENANT_RENT_COLLECTED_EXAMPLE = [
	{ side: "debit", code: "1000", amount_key: "gross", uses_payment_method: true },
	{ side: "credit", code: "4000", amount_key: "amount", uses_payment_method: false },
	{ side: "credit", code: "4100", amount_key: "fee_paid", uses_payment_method: false },
];
